/// <reference path = "../../node_modules/@types/jquery/index.d.ts" />
/// <reference path = "../../node_modules/@types/jqueryui/index.d.ts" />

import listenForClick from "./clickHandler";
import { getFirstFormAnchorID } from "./functions";

const closedClass = "mi-closed";
const childOpenedClass = "mi-child-opened";

// Toggle the following div.
export function handleToggle() {
    let allToggleHeader = document.querySelectorAll(".mi-toogle-header");
    allToggleHeader.forEach(_header => {
        let header = _header as HTMLElement;
        if (header.classList.contains("mi-skip-toggle"))
            return;

        let detail = header.nextElementSibling as HTMLElement;

        let updateHeaderStyle = () => {
            if (detail.classList.contains(closedClass))
                header.classList.remove(childOpenedClass);
            else
                header.classList.add(childOpenedClass);
        }
        updateHeaderStyle();

        listenForClick(header, () => {
            if (detail.classList.contains(closedClass))
                detail.classList.remove(closedClass);
            else
                detail.classList.add(closedClass);

            updateHeaderStyle();
        });
    });
}

// The static overlay buttons (Order now / Requeat a quote) at lower right corner.
export function handleAddToCartOrRequestQuote(){
    if (!(window as any).mi_isSingleProductPage)
        return;

    let inquiryOnly = (window as any).mi_inquiryOnly;

    let orderBtn = document.querySelector("#mi-order-btn") as HTMLElement;
    let requestQuoteBtn = document.querySelector("#mi-request-quote-btn") as HTMLElement;

    if (inquiryOnly){
        let firstFormId = getFirstFormAnchorID();
        if (firstFormId){
            requestQuoteBtn.classList.remove("mi-hidden");

            let anchor = requestQuoteBtn.querySelector("a");
            anchor.href = firstFormId;
        }
        else{
/////////////
            console.log("No request form is found, should not show the inquiry button");
//////////
        }
    }
    else
        orderBtn.classList.remove("mi-hidden");
}